import React from 'react';
import { Building2, MapPin } from 'lucide-react';
import { moveLines } from './dayMoveLines';

/**
 * The trail after the punch-in, one short line per move. Renders nothing for a
 * day spent in one place, which is most of them.
 */
const DayMoves = ({ moves, formatTime, className = '' }) => {
  const lines = moveLines(moves, formatTime);
  if (!lines.length) return null;
  return (
    <ul className={`space-y-0.5 text-xs text-gray-600 ${className}`}>
      {lines.map((line) => {
        const Icon = line.mode === 'OFFICE' ? Building2 : MapPin;
        return (
          <li key={line.id} className="flex items-start gap-1">
            <Icon size={11} className="mt-0.5 shrink-0 text-gray-400" />
            <span>
              <span className="font-medium text-gray-700">{line.label}</span> · {line.time}
              {line.detail ? <span className="text-gray-500"> · {line.detail}</span> : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default DayMoves;
